import Icon from '../components/Icon.vue'

Icon.register({
  blender: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 384c35.3 0 64 28.7 64 64v32c0 17.7-14.3 32-32 32h-320c-17.7 0-32-14.3-32-32v-32c0-35.3 28.7-64 64-64h256zM288 480c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM328 64c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h157.8l-17.5 64h-140.4c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h131.6l-17.5 64h-114.2c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h105.5l-17.5 64h-256l-8.7-96h-103.3c-26.5 0-48-21.5-48-48v-160c0-26.5 21.5-48 48-48h464l-17.5 64h-166.5zM64 192h81.5l-11.6-128h-69.8v128z'
      }
    ]
  }
})
